import * as TYPES from '../types';

const initialState = {
    pagination: {
        totalCount: 0,
        activePage: 1,
        itemsCountPerPage: 1,
        totalItemsCount: 10,
        pageRangeDisplayed: 8,
    },
    reports: [],
    downloads: [],
    single_report: {},
    single_product: [],
    date_from: new Date(),
    date_to: new Date(),
    loading: false,
    mini_loading: false,
    isSearchable: true,
    main_report_page: false,
    edit_page: false,
    delete_modal: false,
    history_page: false,
    print_modal: false,
    main_url: '/inventory/reports',
    create_url: '/inventory/reports/create',
    edit_url: '/inventory/reports/edit',
    history_url: '/inventory/reports/history',
    product_url: '/inventory/reports/history/product',
    rows_to_delete: null,
    sort_order_name: null,
    sort_order_direction: null,
    set_row_checked: false,
    remarks: '',
    report_search: '',
    download_search: '',
    products: [],
    generate_report: false,
    reportData: {
        name: '',
        jobId: null,
        total_docs: 0,
        status: null,
        fileUrl: null,
    },
    test_result: '',
};

const ReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPES.GET_REPORTS:
            return {
                ...state,
                reports: action.payload.reports,
                pagination: action.payload.pagination,
                set_row_checked: false,
            };
        case TYPES.GET_REPORT_DOWNLOADS:
            return {
                ...state,
                downloads: action.payload.downloads,
                pagination: action.payload.pagination,
                set_row_checked: false,
            };
        case TYPES.GET_SINGLE_REPORT:
            return {
                ...state,
                single_report: action.payload,
            };
        case TYPES.REPORT_INPUT_CHANGE:
            return {
                ...state,
                single_report: {
                    ...state.single_report,
                    [action.payload.key]: action.payload.value,
                },
                formChange: true,
            };
        case TYPES.REPORT_SEARCH:
            return {
                ...state,
                report_search: action.payload,
            };
        case TYPES.REPORT_DOWNLOAD_SEARCH:
            return {
                ...state,
                download_search: action.payload,
            };
        case TYPES.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case TYPES.SET_PAGE:
            if (action.payload.page == 'main_report_page') {
                return {
                    ...state,
                    edit_page: false,
                    [action.payload.page]: action.payload.status,
                };
            } else if (action.payload.page == 'edit_page') {
                return {
                    ...state,
                    main_report_page: false,
                    edit_url: action.payload.edit_url,
                    [action.payload.page]: action.payload.status,
                };
            } else {
                return {
                    ...state,
                    [action.payload.page]: action.payload.status,
                };
            }
        case TYPES.SORT_BY_COLUMN:
            return {
                ...state,
                sort_order_name: action.payload.sort_order_name,
                sort_order_direction: action.payload.sort_order_direction,
            };
        case TYPES.GET_ROWS_TO_DELETE:
            return {
                ...state,
                rows_to_delete: action.payload,
            };
        case TYPES.SET_ROW_CHECKED:
            return {
                ...state,
                set_row_checked: true,
            };
        case TYPES.CLEAR_REPORT:
            return {
                ...state,
                single_report: [],
                report_search: '',
                download_search: '',
                loading: false,
                main_report_page: false,
                edit_page: false,
                delete_modal: false,
                main_url: '/inventory/reports',
                create_url: '/inventory/reports/create',
                edit_url: '/inventory/reports/edit',
                sort_order_name: null,
                sort_order_direction: null,
                rows_to_delete: null,
                set_row_checked: false,
                formChange: false,
                test_result: '',
            };
        case TYPES.SET_MODAL:
            return {
                ...state,
                [action.payload.modal]: action.payload.status,
            };
        // redux/reducers/reports.reducer.js

        case TYPES.GENERATE_BTN:
            const { id, status } = action.payload;
            return {
                ...state,
                reports: state.reports.map((report) =>
                    report._id === id ? { ...report, generate: status } : report
                ),
            };
        case TYPES.SET_MODAL_GENERATE:
            return {
                ...state,
                generate_report: action.payload,
            };
        case TYPES.REPORT_JOB:
            return {
                ...state,
                // reports: [],
                // pagination: {},
                reportData: {
                    jobId: action.payload.jobId,
                    name: action.payload.name,
                    // total_docs: action.payload.total_docs,
                    status: 'queued',
                    fileUrl: null,
                },
            };
        case TYPES.REPORT_STATUS_UPDATE:
            return {
                ...state,
                reportData: {
                    ...state.reportData,
                    status: action.payload.status,
                    fileUrl: action.payload.fileUrl || null,
                },
            };
        case TYPES.TEST_REPORT_RESULT:
            return {
                ...state,
                test_result: action.payload,
            };
        default:
            return state;
            break;
    }
};

export default ReportsReducer;
